import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

export function Textarea({ className, ...props }: ComponentProps<'textarea'>) {
  return (
    <textarea
      className={cn(
        'border border-line-bold bg-surface-strong px-3 py-2 text-sm leading-relaxed',
        'focus:outline-2 focus:outline-offset-0 focus:outline-brand-700',
        className,
      )}
      {...props}
    />
  );
}
